import { Component, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { CoreJssProxyModule } from '@core/jss-proxy';
import type { TextField } from '@core/jss-proxy';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';

@Component({
  selector: 'wl-generic-products-section',
  templateUrl: './generic-products-section.component.html',
  styleUrls: [
    './generic-products-section.component.ed.scss',
    './generic-products-section.component.essent.scss',
  ],
  standalone: true,
  imports: [CoreJssProxyModule, RichTextWrapperComponent],
})
export class GenericProductsSectionComponent {
  readonly rendering = input<InnogyComponentRendering>();
  readonly title = input<TextField>();
  readonly content = input<TextField>();
}
